import { CASE_REPO } from '@/api/apiModules'
import lang from '@/lang'
import dictionary from '@/utils/dictionary'
export default {
  viewType: 'detail',
  view: {
    tabs: [
      {
        label: 'baseInfo',
        viewMetaData: {
          module: CASE_REPO,
          params: null,
          fillDetailUrl: `${CASE_REPO}/detail`,
          viewType: 'form',
          cb() {},
          view: {
            isSimple: false,
            labelWidth: '140px',
            header: {},
            content: [
              {
                isGroup: true,
                $type: 'group',
                $id: 'base',
                title: 'overview',
                icon: 'sk-icon-overview',
                $items: [
                  {
                    $id: 'testCaseCode',
                    label: 'testcaseMng.testCaseCode'
                  },
                  {
                    $id: 'testCaseName',
                    label: 'testcaseMng.testCaseName'
                  },
                  {
                    $id: 'testCaseCategory',
                    label: 'testcaseMng.testCaseCategory',
                    dataType: 'enum'
                  },
                  {
                    $id: 'testCaseType',
                    label: 'testcaseMng.testCaseType',
                    dataType: 'enum'
                  },
                  {
                    $id: 'testCaseContent',
                    label: 'testcaseMng.testCaseContent'
                  },
                  {
                    $id: 'testCaseScene',
                    label: 'testcaseMng.testCaseScene'
                  },
                  {
                    $id: 'userDemand',
                    label: 'testcaseMng.testUserDemand'
                  },
                  {
                    $id: 'testCaseStep',
                    label: 'testcaseMng.testCaseStep',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.testCaseStep) {
                        return
                      }
                      let testCaseStep = data.testCaseStep.replace(/\n\s*\n/g, '\n')
                      return <div class="wsp-word-break">{testCaseStep}</div>
                    }
                  },
                  {
                    $id: 'remarks',
                    label: '备注【注意事项或限制说明】'
                  },
                  {
                    $id: 'compatibleDTOList',
                    label: '产品&操作系统',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.compatibleDTOList || data.compatibleDTOList.length == 0) {
                        return
                      }
                      const renderItem = []
                      data.compatibleDTOList.forEach(el => {
                        renderItem.push(
                          <div>
                            <el-tag type="success" class="wsp-margin-left-3 wsp-margin-top-3">
                              【{el.productVersion} / {el.os}】
                            </el-tag>
                          </div>
                        )
                      })

                      return renderItem
                    }
                  },
                  {
                    $id: 'testCaseExpectedResult',
                    label: 'testcaseMng.testCaseExpectedResult'
                  },
                  {
                    $id: 'createTime',
                    label: '创建时间',
                    dataType: 'date'
                  },
                  {
                    $id: 'realName',
                    label: '创建人'
                  },
                  {
                    $id: 'sourceTestCase',
                    label: '用例复制来源',
                    dataType: 'custom',
                    custom: function(data, h) {
                      if (!data || !data.sourceTestCase) {
                        return
                      }
                      const renderItem = [
                        <div>
                          <el-tag type={dictionary['testCaseCategory'][data.sourceTestCase.testCaseCategory].type}>
                            {lang.t(dictionary['testCaseCategory'][data.sourceTestCase.testCaseCategory].label)}
                          </el-tag>
                          &nbsp;
                          <el-tag type={dictionary['testCaseType'][data.sourceTestCase.testCaseType].type}>
                            {lang.t(dictionary['testCaseType'][data.sourceTestCase.testCaseType].label)}
                          </el-tag>
                          &nbsp;
                          <span>{data.sourceTestCase.testCaseName}</span>&nbsp;
                          <span>[{data.sourceTestCase.testCaseCode}]</span>
                        </div>
                      ]
                      return renderItem
                    }
                  }
                ]
              }
            ]
          }
        }
      }
    ]
  }
}
